<template>
  <Catalog
    title="Вид работ"
    name-label="Название вида работ"
    description-label="Будет отображаться в объекте, заявках и при выставлении счёта"
    submit-error="Укажите название вида работ."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    v-on="$listeners"
  >
    <template #optional-skeleton>
      <b-row class="mb-2">
        <b-col>
          <b-skeleton width="32%" height="16%" class="mb-2"/>
          <b-skeleton type="input" width="100%" height="30%" class="mb-2"/>
          <b-skeleton width="50%" height="15%" class="mb-0"/>
        </b-col>
      </b-row>
    </template>

    <template v-slot:optional-fields="{ model }">
      <b-form-group
        id="group-vacancy"
        label="Название вакансии"
        label-for="input-vacancy"
        description="Будет отображаться у исполнителя"
      >
        <b-form-input
          id="input-name"
          type="text"
          size="sm"
          v-model="model.vacancy"
          trim
        />
      </b-form-group>
    </template>
  </Catalog>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import Catalog from "../Catalog.vue";

export default {
  name: 'WorkTypeCatalog',
  components: { Catalog },
  mixins: [ catalogs ],
  methods: {
    async fetchData(id) {
      return await this.getWorkTypeById(id);
    },
    async putData(data) {
      return await this.putWorkType(data)
    },
    async postData(data) {
      return await this.postWorkType(data)
    },
  }
}
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/Catalogs/WorkType/WorkTypeCatalog.vue